<template>
  <v-row :id="id" class="primerica-benefits pb-10 mb-16">
    <v-col cols="12" class="hero mx-0 px-0 pt-0 pb-0">
      <slot name="hero" />
    </v-col>
    <v-col class="content px-0" cols="12">
      <slot name="content" />
    </v-col>
    <v-row v-if="displayContactRep">
      <ContactRepFooter v-if="agent" />
    </v-row>
    <v-container class="footer pb-8 mb-8" v-if="footerContent">
      <v-row>
        <v-col>
          <h2 class="text-h2 font-weight-bold ml-4 mr-4" :aria-label="footerContent.title">
            {{ footerContent.title }}
          </h2>
          <div
            class="subtitle font-weight-bold pl-2 pr-2 ml-4 mr-4"
            v-html="footerContent.subtitle"
          />
        </v-col>
      </v-row>
      <v-row class="text-body text-center mx-4" justify="space-between">
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          v-for="(card, c) in footerContent.cards"
          :key="c"
        >
          <v-card class="height-full px-2 py-6" color="#254971">
            <div class="icon">
              <v-img :src="card.icon" alt="Card Icon" />
            </div>
            <div class="body-1" v-html="card.text" />
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mx-4">
        <v-col>
          <div class="text-h6 font-weight-regular text-left" v-html="footerContent.subtext" />
          <div class="text-h6 font-weight-regular pt-2 text-left" v-html="footerContent.subtext2" />
          <div class="text-h6 font-weight-regular pt-2 text-left" v-html="footerContent.subtext3" />
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import ContactRepFooter from './ContactRep/ContactRepFooter.vue';
import { defineComponent } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';

export default defineComponent({
  name: 'PrimericaBenefits',
  components: {
    ContactRepFooter,
  },
  props: {
    footerContent: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      required: true,
    },
    displayContactRep: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  computed: {
    ...mapState(useGlobalStore, ['agents', 'getAgent']),
    agent() {
      return this.agents.length === 1 ? this.agents[0] : null;
    },
  },
});
</script>

<style lang="scss">
.primerica-benefits {
  .height-full {
    height: 100%;
  }
  .heading_two {
    color: #4a4a4a;
    font-size: 32px;
    font-weight: 600;
  }
  .icon {
    width: 55px;
    height: 55px;
    margin: 0 auto;
    border-radius: 50%;
  }
  .sub-text {
    font-size: 12px;
  }
  .hero {
    position: relative;
    h1 {
      color: #fff;
      bottom: 0;
      padding: 0 0 25px 25px;
      position: absolute;
      font-size: 20px;
      max-width: 80%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .content {
    padding: 30px 100px;
    .heading_three {
      margin: 10px 0 0;
      font-size: 24px;
      font-weight: bold;
    }
    .heading_two {
      width: 100%;
      margin: 0;
      text-align: left;
      font-size: 2rem;
      font-weight: bold;
    }
    .text {
      font-size: 20px;
    }
    .right {
      .text {
        margin: 20px 0 40px;
      }
      &.last .text {
        margin: 25px 0 10px;
      }
    }
    @media only screen and (max-width: 760px) {
      padding: 1rem;
    }
  }
  .footer {
    color: #fff;
    padding: 25px 0;
    text-align: center;
    background: #063562;
    .body {
      > div:nth-child(3n + 1) .card {
        margin-left: 25px;
      }
      > div:not(:nth-child(5)) .card .text {
        padding: 0 0 40px;
      }
      .card {
        height: 100%;
        padding: 10px;
        margin-right: 25px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.1);
        .text {
          padding: 0 0 10px;
          font-size: 14px;
          font-weight: 600;
        }
        @media only screen and (max-width: 760px) {
          margin-left: 25px;
        }
      }
    }
    .heading_two {
      width: 100%;
      font-size: 26px;
      color: #fff;
    }
    .icon {
      margin: 10px auto 20px;
    }
    .subtitle {
      color: #96ceff;
      font-size: 20px;
      font-weight: 500;
      margin: 15px 0 40px;
    }
    .sub-text {
      padding: 0 75px;
    }
  }
}
</style>
